import { ReactComponent as FenixLogo } from 'Components/UI_Library/Icons/FenixLogo.svg';
import { ReactComponent as Help } from 'Components/UI_Library/Icons/MobileIcons/Help.svg';
import classes from './NoCompanySelectedMenu.module.css';
import Home from '../Home';

const NoCompanySelectedMenu = () => (
    <div className={classes.wrapper}>
        <div className={classes.logo}>
            <FenixLogo />
        </div>
        <Home classNames={{ navLink: classes.navLink, navIcon: classes.navIcon, navText: classes.navText }} />
        <div className={classes.divider} />
        <div className={classes.bottomSection}>
            <div className={classes.divider} />
            <a className={classes.navLink} href="https://knowledge.paytron.com/" target="_blank" rel="noreferrer">
                <div className={classes.navIcon}>
                    <Help />
                </div>
                <span className={classes.navText}>Help</span>
            </a>
        </div>
    </div>
);

export default NoCompanySelectedMenu;
